var CardItem = function () {

    this.init = function () {

        equalize();
    }

    return this.init();
}

var equalize = function () {

    if ($(window).width() < 768) {
        return
    }

    //componente card block
    $('.card-block').each(function () {

        var heightTitle = 0;
        var heightDescription = 0;

        $(this).find('.title').each(function () {

            if (!$(this).hasClass("heightAdded") && !$(this).hasClass("side-content")) {
                if ($(this).outerHeight() > heightTitle)
                    heightTitle = $(this).outerHeight();
            }
        });

        $(this).find('.description p').each(function () {

            if (!$(this).hasClass("heightAdded") && !$(this).hasClass("side-content")) {
                if ($(this).outerHeight() > heightDescription)
                    heightDescription = $(this).outerHeight();
            }
        });

        $(this).find('.title').each(function () {

            if (!$(this).hasClass("heightAdded") && !$(this).hasClass("side-content")) {
                $(this).outerHeight(heightTitle);
            }
        });

        $(this).find('.description p').each(function () {

            if (!$(this).hasClass("heightAdded") && !$(this).hasClass("side-content")) {
                $(this).outerHeight(heightDescription);
            }
        });
    });

    //component card list
    //title
    $(".news").each(function () {

        var heightTitle = 0;
        var heightDescription = 0;

        $(this).find('[data-component="card-item"] .title').each(function () {

            if (!$(this).hasClass("heightAdded") && !$(this).hasClass("side-content") && (!$(this).hasClass("card6") || ($(window).width() > 767 && $(window).width() < 992))) {
                if ($(this).parents(".tab-content").hasClass("current"))
                    if ($(this).outerHeight() > heightTitle)
                        heightTitle = $(this).outerHeight();
            }
        });

        $(this).find('[data-component="card-item"] .title').each(function () {

            if (!$(this).hasClass("heightAdded") && !$(this).hasClass("side-content") && (!$(this).hasClass("card6") || ($(window).width() > 767 && $(window).width() < 992))) {
                if ($(this).parents(".tab-content").hasClass("current"))
                    $(this).outerHeight(heightTitle);
            }
        });

        $(this).find('[data-component="card-item"] .title').each(function () {

            if (!$(this).hasClass("heightAdded") && !$(this).hasClass("side-content") && (!$(this).hasClass("card6") || ($(window).width() > 767 && $(window).width() < 992))) {
                if ($(this).parents(".tab-content").hasClass("current"))
                    $(this).addClass("heightAdded");
            }
        });

        //description
        $(this).find('[data-component="card-item"] .description').each(function () {

            if (!$(this).hasClass("heightAdded") && !$(this).hasClass("side-content") && (!$(this).hasClass("card6") || ($(window).width() > 767 && $(window).width() < 992))) {
                if ($(this).parents(".tab-content").hasClass("current"))
                    if ($(this).outerHeight() > heightDescription)
                        heightDescription = $(this).outerHeight();
            }
        });

        $(this).find('[data-component="card-item"] .description').each(function () {

            if (!$(this).hasClass("heightAdded") && !$(this).hasClass("side-content") && (!$(this).hasClass("card6") || ($(window).width() > 767 && $(window).width() < 992))) {
                if ($(this).parents(".tab-content").hasClass("current"))
                    $(this).outerHeight(heightDescription);
            }
        });

        $(this).find('[data-component="card-item"] .description').each(function () {

            if (!$(this).hasClass("heightAdded") && !$(this).hasClass("side-content") && (!$(this).hasClass("card6") || ($(window).width() > 767 && $(window).width() < 992))) {
                if ($(this).parents(".tab-content").hasClass("current"))
                    $(this).addClass("heightAdded");
            }
        });
    });
};